import { render, staticRenderFns } from "./DownloadSimple.vue?vue&type=template&id=4fb71daa&scoped=true"
import script from "./DownloadSimple.vue?vue&type=script&lang=js"
export * from "./DownloadSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb71daa",
  null
  
)

export default component.exports